import { inject, Injectable } from '@angular/core';
import { catchError, forkJoin, of } from 'rxjs';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private userService = inject(UsersService);

  init() {
    return forkJoin({
      user: this.userService.getUserInfo().pipe(
        catchError((err) => {
          console.log(err)
          return of(null); // continua inicialização mesmo com erro
        })
      ),
    });
  }
}
